//Used to invoke transitions in the TransitionManager and will handle transition if the transition is for the current page.
angular.module('aprima-legacy-common').service('TransitionManagerJs', ['$log', '$state', 'AppRoutes', '_', 'WebViewManager', '$rootScope', '$transitions',
    function($log, $state, AppRoutes, _, WebViewManager, $rootScope, $transitions) {
        'use strict';

        var previousTransition;

        $transitions.onStart({}, function(transition) {
            var fromState = transition.from() || {};
            var fromStateName = fromState && fromState.name || '';
            var toState = transition.targetState() || {};
            var toStateName = toState && toState.name() || '';
            var appRoute = _(AppRoutes).findKey({state: fromStateName || toStateName});

            previousTransition = {
                appRoute: appRoute,
                opts: _.cloneDeep(transition.params('from')),
            };
        });

        var transitionToState = function(transition, replaceState){
            transition = formatTransition(transition);

            if(!transition){
                return;
            }

            var targetRoute = AppRoutes[transition.appRoute];

            if(!targetRoute) {
                $log.warn('Unable to find AppRoute: "' + transition.appRoute + '". Aborting transition.');
                return false;
            }

            if(!_.isBoolean(transition.opts.replaceCurrentState)){
                if(_.isBoolean(replaceState)){
                    transition.opts.replaceCurrentState = replaceState;
                }
                else if(!$state.current || $state.current.name !== targetRoute.state){
                    transition.opts.replaceCurrentState = false;
                }
                else{
                    transition.opts.replaceCurrentState = true;
                }
            }

            if(targetRoute.options){
                transition.opts = _.merge(transition.opts, targetRoute.options);
            }

            $rootScope.$broadcast('TransitionActivated', transition);

            return WebViewManager.activateView(targetRoute, transition);
        };

        var replaceCurrentState = function(transition){
            transitionToState(transition, true);
        };

        function getPreviousTransition(){
            return previousTransition;
        }

        function formatTransition(transition){
            if (!transition) {
                $log.warn('Cannot transition to null or undefined transition');
                return;
            }

            transition = _.defaults(transition, {
                type: 'transition',
                appRoute: '',
                opts: {}
            });

            $log.info('TransitionManager postMessage to ' + JSON.stringify(transition));

            return transition;
        }

        var goBack = function(){
            WebViewManager.goBack();
        };

        return {
            transition: transitionToState,
            replaceCurrentState: replaceCurrentState,
            goBack: goBack,
            getPreviousTransition: getPreviousTransition
        };
    }]);
